/**
 * LabelsQrPanel — the 'labels-qr' area: garment label size and layout, test
 * prints, and bin / packing-shelf QR code sheets. See areas.ts 'labels-qr'.
 */
import { Archive, Grid3x3, Layout, Package, Printer, Ruler } from 'lucide-react';
import { SettingsSection } from '../components/console/SettingsSection';
import { LabelSizeSection } from '../components/LabelSizeSection';
import { LabelLayoutSection } from '../components/label-layout/LabelLayoutSection';
import { TestPrintSection } from '../sections/TestPrintSection';
import { BinQRSection } from '../components/BinQRSection';
import { PackingShelfQRSection } from '../components/qr-codes/PackingShelfQRSection';
import { FilmStorageQRSection } from '../components/FilmStorageQRSection';

export function LabelsQrPanel() {
  return (
    <>
      <SettingsSection
        id="label-size"
        title="Label size"
        description="Default shipping-label dimensions and custom sizes."
        icon={Ruler}
        scope="org"
      >
        <LabelSizeSection />
      </SettingsSection>

      <SettingsSection
        id="label-layout"
        title="Label layout editor"
        description="Drag-and-drop editor for the garment label."
        icon={Layout}
        scope="org"
      >
        <LabelLayoutSection />
      </SettingsSection>

      <SettingsSection
        id="test-print"
        title="Test print"
        description="Print a sample garment label to check alignment."
        icon={Printer}
        scope="org"
      >
        <TestPrintSection />
      </SettingsSection>

      <SettingsSection
        id="bin-qr"
        title="Bin QR codes"
        description="Generate and print QR code sheets for production bins."
        icon={Grid3x3}
        scope="location"
      >
        <BinQRSection />
      </SettingsSection>

      <SettingsSection
        id="shelf-qr"
        title="Packing shelf QR"
        description="Generate QR codes for packing shelves."
        icon={Package}
        scope="location"
      >
        <PackingShelfQRSection />
      </SettingsSection>

      <SettingsSection
        id="film-storage-qr"
        title="Film storage QR"
        description="Print QR labels for DTF pigeon holes and shelves."
        icon={Archive}
        scope="location"
      >
        <FilmStorageQRSection />
      </SettingsSection>
    </>
  );
}
